"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetGreetIndex = exports.IndexedRole = exports.CompositionEvent = exports.Composition = exports.RoomSessionEvent = exports.SessionPhoto = exports.Photo = exports.RoomSession = exports.RoomSessionDownloads = exports.RoomParticipant = exports.MediaTrackInfo = exports.Transcode = exports.TranscodeComposition = exports.Room = exports.Session = exports.Role = exports.Event = exports.BaseEvent = exports.EventWatermark = exports.WatermarkPosition = exports.EventAssets = exports.Asset = exports.Slot = exports.TranscodeTypes = exports.TranscodeCompositionStatuses = exports.CompositionOrientations = exports.WatermarkSource = exports.TranscodeStatus = exports.RoomSessionStatus = exports.RoomStatus = exports.RoleType = void 0;
const toccata_1 = require("@musicaudienceexchange/toccata");
var RoleType;
(function (RoleType) {
    RoleType["fan"] = "fan";
    RoleType["artist"] = "artist";
    RoleType["manager"] = "manager";
    RoleType["spectator"] = "spectator";
})(RoleType = exports.RoleType || (exports.RoleType = {}));
var RoomStatus;
(function (RoomStatus) {
    RoomStatus["pending"] = "pending";
    RoomStatus["ready"] = "ready";
    RoomStatus["live"] = "live";
    RoomStatus["complete"] = "complete";
    RoomStatus["canceled"] = "canceled";
})(RoomStatus = exports.RoomStatus || (exports.RoomStatus = {}));
var RoomSessionStatus;
(function (RoomSessionStatus) {
    RoomSessionStatus["pending"] = "pending";
    RoomSessionStatus["ended"] = "ended";
    RoomSessionStatus["processing"] = "processing";
    RoomSessionStatus["transcoding"] = "transcoding";
    RoomSessionStatus["processed"] = "processed";
    RoomSessionStatus["complete"] = "complete";
    RoomSessionStatus["retry"] = "retry";
    RoomSessionStatus["invalid"] = "invalid";
    RoomSessionStatus["blocked"] = "blocked";
    RoomSessionStatus["failed"] = "failed";
})(RoomSessionStatus = exports.RoomSessionStatus || (exports.RoomSessionStatus = {}));
var TranscodeStatus;
(function (TranscodeStatus) {
    TranscodeStatus["processing"] = "processing";
    TranscodeStatus["success"] = "success";
    TranscodeStatus["error"] = "error";
    TranscodeStatus["fail"] = "fail";
})(TranscodeStatus = exports.TranscodeStatus || (exports.TranscodeStatus = {}));
var WatermarkSource;
(function (WatermarkSource) {
    WatermarkSource["custom"] = "custom";
    WatermarkSource["setlive"] = "setlive";
})(WatermarkSource = exports.WatermarkSource || (exports.WatermarkSource = {}));
exports.CompositionOrientations = ['landscape', 'portrait'];
exports.TranscodeCompositionStatuses = ['processing', 'complete', 'blocked'];
exports.TranscodeTypes = ['meet-greet'];
// /meet_greet_event/
class Slot extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString()
], Slot.prototype, "eventId", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Slot.prototype, "filledAt", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Slot.prototype, "recipientId", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Slot.prototype, "requestorId", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Slot.prototype, "reservedAt", void 0);
__decorate([
    toccata_1.validator.IsString()
], Slot.prototype, "sessionId", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Slot.prototype, "uid", void 0);
exports.Slot = Slot;
class Asset extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Asset.prototype, "path", void 0);
__decorate([
    toccata_1.validator.IsUrl({
        protocols: ['http', 'https'],
        allow_underscores: true,
        require_tld: false,
    }),
    toccata_1.validator.IsOptional()
], Asset.prototype, "url", void 0);
exports.Asset = Asset;
class EventAssets extends toccata_1.Model {
}
__decorate([
    (0, toccata_1.TransformValidateModel)(Asset),
    toccata_1.validator.IsOptional()
], EventAssets.prototype, "preshowBanner", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(Asset),
    toccata_1.validator.IsOptional()
], EventAssets.prototype, "squareBanner", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(Asset),
    toccata_1.validator.IsOptional()
], EventAssets.prototype, "salesVideo", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(Asset),
    toccata_1.validator.IsOptional()
], EventAssets.prototype, "watermarkLandscape", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(Asset),
    toccata_1.validator.IsOptional()
], EventAssets.prototype, "watermarkPortrait", void 0);
exports.EventAssets = EventAssets;
class WatermarkPosition extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.top = 0;
        this.left = 0;
        this.width = 0;
        this.height = 0;
    }
}
__decorate([
    toccata_1.validator.IsNumber()
], WatermarkPosition.prototype, "top", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], WatermarkPosition.prototype, "left", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], WatermarkPosition.prototype, "width", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], WatermarkPosition.prototype, "height", void 0);
exports.WatermarkPosition = WatermarkPosition;
class EventWatermark extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.includesGradient = false;
    }
}
__decorate([
    toccata_1.validator.IsString()
], EventWatermark.prototype, "asset", void 0);
__decorate([
    toccata_1.validator.IsBoolean()
], EventWatermark.prototype, "includesGradient", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(WatermarkPosition)
], EventWatermark.prototype, "desktopPosition", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(WatermarkPosition)
], EventWatermark.prototype, "mobilePosition", void 0);
__decorate([
    toccata_1.validator.IsEnum(WatermarkSource)
], EventWatermark.prototype, "source", void 0);
exports.EventWatermark = EventWatermark;
/**
 * This class is used for the createSession request
 * as the data payload
 */
class BaseEvent extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.sessionDuration = 60;
    }
}
__decorate([
    toccata_1.validator.IsString()
], BaseEvent.prototype, "artistGroupId", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], BaseEvent.prototype, "name", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(EventAssets),
    toccata_1.validator.IsOptional()
], BaseEvent.prototype, "assets", void 0);
__decorate([
    toccata_1.validator.IsString()
], BaseEvent.prototype, "checkoutDescription", void 0);
__decorate([
    toccata_1.validator.IsArray(),
    toccata_1.validator.IsOptional()
], BaseEvent.prototype, "checkoutWhatToExpect", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], BaseEvent.prototype, "startDate", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], BaseEvent.prototype, "unitPrice", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], BaseEvent.prototype, "sessionDuration", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(EventWatermark),
    toccata_1.validator.IsOptional()
], BaseEvent.prototype, "watermark", void 0);
exports.BaseEvent = BaseEvent;
// /meet_greet_event/<eventId>
class Event extends BaseEvent {
    constructor() {
        super(...arguments);
        // read only
        this.sessionCount = 0;
    }
}
__decorate([
    toccata_1.validator.IsString()
], Event.prototype, "artist", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Event.prototype, "billingAccountId", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Event.prototype, "endDate", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], Event.prototype, "processingFeeAmount", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], Event.prototype, "sessionCount", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Event.prototype, "createdBy", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Event.prototype, "createdAt", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Event.prototype, "updatedBy", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Event.prototype, "updateAt", void 0);
exports.Event = Event;
// /meet_greet/<sessionId>/roles/<uid>
class Role extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.isAdmin = false;
    }
}
__decorate([
    toccata_1.validator.IsEnum(RoleType)
], Role.prototype, "role", void 0);
__decorate([
    toccata_1.validator.IsBoolean(),
    toccata_1.validator.IsOptional()
], Role.prototype, "isAdmin", void 0);
exports.Role = Role;
// /meet_greet/<sessionId>
class Session extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.salesHold = false;
        this.paused = false;
    }
}
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Session.prototype, "eventName", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(EventAssets),
    toccata_1.validator.IsOptional()
], Session.prototype, "eventAssets", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Session.prototype, "artistGroup", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Session.prototype, "startDate", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Session.prototype, "endDate", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Session.prototype, "lockTimestamp", void 0);
__decorate([
    toccata_1.validator.IsString()
], Session.prototype, "eventId", void 0);
__decorate([
    toccata_1.validator.IsOptional()
], Session.prototype, "liveRoom", void 0);
__decorate([
    toccata_1.validator.IsOptional()
], Session.prototype, "managerStatus", void 0);
__decorate([
    toccata_1.validator.IsBoolean()
], Session.prototype, "mirrorArtistForFan", void 0);
__decorate([
    toccata_1.validator.IsBoolean()
], Session.prototype, "salesHold", void 0);
__decorate([
    toccata_1.validator.IsBoolean()
], Session.prototype, "paused", void 0);
__decorate([
    toccata_1.validator.IsOptional()
], Session.prototype, "participantCount", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Session.prototype, "name", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Session.prototype, "createdBy", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Session.prototype, "createdAt", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Session.prototype, "updatedBy", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Session.prototype, "updateAt", void 0);
exports.Session = Session;
// /meet_greet/<sessionId>/rooms/<uid>
class Room extends toccata_1.Model {
    constructor() {
        super(...arguments);
        // For admin
        this.photoCount = 0;
        this.chatCount = 0;
        this.videoCount = 0;
    }
}
__decorate([
    toccata_1.validator.IsBoolean(),
    toccata_1.validator.IsOptional()
], Room.prototype, "noText", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Room.prototype, "phone", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Room.prototype, "userBio", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Room.prototype, "userLocation", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], Room.prototype, "photoCount", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], Room.prototype, "chatCount", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], Room.prototype, "videoCount", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], Room.prototype, "priority", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Room.prototype, "sessionStart", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], Room.prototype, "connectionQuality", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], Room.prototype, "totalCalls", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], Room.prototype, "totalTime", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Room.prototype, "currentSession", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Room.prototype, "status", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Room.prototype, "startTime", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Room.prototype, "audio", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Room.prototype, "online", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Room.prototype, "video", void 0);
exports.Room = Room;
class TranscodeComposition extends toccata_1.Model {
}
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], TranscodeComposition.prototype, "completedAt", void 0);
__decorate([
    toccata_1.validator.IsIn(exports.TranscodeCompositionStatuses),
    toccata_1.validator.IsOptional()
], TranscodeComposition.prototype, "status", void 0);
__decorate([
    toccata_1.validator.IsString()
], TranscodeComposition.prototype, "compositionId", void 0);
__decorate([
    toccata_1.validator.IsIn(exports.CompositionOrientations)
], TranscodeComposition.prototype, "orientation", void 0);
exports.TranscodeComposition = TranscodeComposition;
class Transcode extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString()
], Transcode.prototype, "eventId", void 0);
__decorate([
    toccata_1.validator.IsString()
], Transcode.prototype, "roomId", void 0);
__decorate([
    toccata_1.validator.IsString()
], Transcode.prototype, "sessionId", void 0);
__decorate([
    toccata_1.validator.IsIn(exports.TranscodeTypes)
], Transcode.prototype, "type", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Transcode.prototype, "notificationId", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Transcode.prototype, "createdAt", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(TranscodeComposition, { each: true })
], Transcode.prototype, "compositions", void 0);
exports.Transcode = Transcode;
/**
 * All fields are optional as this object is filled out as
 * Twilio webhooks come in and the payloads from the webhook
 * calls differ based on the type of event received.
 * The result is an object with the track information needed
 * to transcode the video properly.
 */
class MediaTrackInfo extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MediaTrackInfo.prototype, "duration", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MediaTrackInfo.prototype, "mediaUri", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MediaTrackInfo.prototype, "recordingStart", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MediaTrackInfo.prototype, "recordingEnded", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MediaTrackInfo.prototype, "recordingId", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MediaTrackInfo.prototype, "recordingUri", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MediaTrackInfo.prototype, "size", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MediaTrackInfo.prototype, "track", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MediaTrackInfo.prototype, "trackStart", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MediaTrackInfo.prototype, "trackEnd", void 0);
exports.MediaTrackInfo = MediaTrackInfo;
class RoomParticipant extends toccata_1.Model {
}
__decorate([
    (0, toccata_1.TransformValidateModel)(MediaTrackInfo)
], RoomParticipant.prototype, "audio", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(MediaTrackInfo)
], RoomParticipant.prototype, "video", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomParticipant.prototype, "connectedAt", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomParticipant.prototype, "disconnectedAt", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomParticipant.prototype, "startedAt", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomParticipant.prototype, "endedAt", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomParticipant.prototype, "sid", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomParticipant.prototype, "uid", void 0);
exports.RoomParticipant = RoomParticipant;
/**
 * This is the object inside a room session that holds the paths
 * to the video downloads
 */
class RoomSessionDownloads extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSessionDownloads.prototype, "landscape", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSessionDownloads.prototype, "portrait", void 0);
exports.RoomSessionDownloads = RoomSessionDownloads;
// /meet_greet/<sessionId>/rooms/<uid>/sessions/<RoomSessionId>
class RoomSession extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.doNotTranscode = false;
    }
}
__decorate([
    (0, toccata_1.TransformValidateModel)(RoomParticipant)
], RoomSession.prototype, "artist", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RoomParticipant)
], RoomSession.prototype, "fan", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSession.prototype, "room", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSession.prototype, "sid", void 0);
__decorate([
    toccata_1.validator.IsEnum(RoomSessionStatus)
], RoomSession.prototype, "status", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RoomSessionDownloads),
    toccata_1.validator.IsOptional()
], RoomSession.prototype, "downloads", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSession.prototype, "endedAt", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RoomSessionDownloads),
    toccata_1.validator.IsOptional()
], RoomSession.prototype, "source", void 0);
__decorate([
    toccata_1.validator.IsBoolean(),
    toccata_1.validator.IsOptional()
], RoomSession.prototype, "doNotTranscode", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], RoomSession.prototype, "startTime", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSession.prototype, "transcodeMessage", void 0);
__decorate([
    toccata_1.validator.IsEnum(TranscodeStatus),
    toccata_1.validator.IsOptional()
], RoomSession.prototype, "transcodeStatus", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSession.prototype, "transcodingStage", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], RoomSession.prototype, "transcodeFrom", void 0);
exports.RoomSession = RoomSession;
// /meet_greet/<sessionId>/rooms/<uid>/photos/<photoId>
class Photo extends toccata_1.Model {
}
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Photo.prototype, "countdownBegin", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Photo.prototype, "created", void 0);
__decorate([
    toccata_1.validator.IsString()
], Photo.prototype, "status", void 0);
__decorate([
    toccata_1.validator.IsString()
], Photo.prototype, "requestedBy", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RoomSessionDownloads),
    toccata_1.validator.IsOptional()
], Photo.prototype, "downloads", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(RoomSessionDownloads),
    toccata_1.validator.IsOptional()
], Photo.prototype, "source", void 0);
__decorate([
    toccata_1.validator.IsOptional()
], Photo.prototype, "uploads", void 0);
exports.Photo = Photo;
class SessionPhoto extends Photo {
}
__decorate([
    toccata_1.validator.IsString()
], SessionPhoto.prototype, "id", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], SessionPhoto.prototype, "offset", void 0);
exports.SessionPhoto = SessionPhoto;
class RoomSessionEvent extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString()
], RoomSessionEvent.prototype, "AccountSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSessionEvent.prototype, "ParticipantIdentity", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSessionEvent.prototype, "ParticipantSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSessionEvent.prototype, "RecordingSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSessionEvent.prototype, "RecordingUri", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSessionEvent.prototype, "RoomName", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSessionEvent.prototype, "RoomSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSessionEvent.prototype, "SourceSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSessionEvent.prototype, "StatusCallbackEvent", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSessionEvent.prototype, "Timestamp", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSessionEvent.prototype, "eventId", void 0);
__decorate([
    toccata_1.validator.IsString()
], RoomSessionEvent.prototype, "roomId", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "Codec", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "Container", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "Duration", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "MediaUri", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "OffsetFromTwilioVideoEpoch", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "ParticipantDuration", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "ParticipantStatus", void 0);
__decorate([
    toccata_1.validator.IsEnum(RoleType),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "role", void 0);
__decorate([
    toccata_1.validator.IsEnum(RoomStatus),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "RoomStatus", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "RoomType", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "SequenceNumber", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "Size", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "TrackKind", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "TrackName", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], RoomSessionEvent.prototype, "TrackSid", void 0);
exports.RoomSessionEvent = RoomSessionEvent;
// /meet_greet/<sessionId>/rooms/<uid>/sessions/<sessionId>/compositions/<compositionId>
class Composition extends toccata_1.Model {
    constructor() {
        super(...arguments);
        // optional fields (updated from composition webhook)
        this.progress = 0;
    }
}
__decorate([
    toccata_1.validator.IsString()
], Composition.prototype, "accountSid", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Composition.prototype, "dateCreated", void 0);
__decorate([
    toccata_1.validator.IsIn(exports.CompositionOrientations)
], Composition.prototype, "orientation", void 0);
__decorate([
    toccata_1.validator.IsString()
], Composition.prototype, "roomSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], Composition.prototype, "sessionId", void 0);
__decorate([
    toccata_1.validator.IsString()
], Composition.prototype, "sid", void 0);
__decorate([
    toccata_1.validator.IsArray()
], Composition.prototype, "sources", void 0);
__decorate([
    toccata_1.validator.IsString()
], Composition.prototype, "status", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], Composition.prototype, "progress", void 0);
exports.Composition = Composition;
class CompositionEvent extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString()
], CompositionEvent.prototype, "AccountSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], CompositionEvent.prototype, "CompositionSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], CompositionEvent.prototype, "CompositionUri", void 0);
__decorate([
    toccata_1.validator.IsString()
], CompositionEvent.prototype, "RoomSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], CompositionEvent.prototype, "StatusCallbackEvent", void 0);
__decorate([
    toccata_1.validator.IsString()
], CompositionEvent.prototype, "Timestamp", void 0);
__decorate([
    toccata_1.validator.IsString()
], CompositionEvent.prototype, "eventId", void 0);
__decorate([
    toccata_1.validator.IsString()
], CompositionEvent.prototype, "roomId", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], CompositionEvent.prototype, "Duration", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], CompositionEvent.prototype, "MediaUri", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], CompositionEvent.prototype, "PercentageDone", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], CompositionEvent.prototype, "SecondsRemaining", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], CompositionEvent.prototype, "Size", void 0);
exports.CompositionEvent = CompositionEvent;
class IndexedRole extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString()
], IndexedRole.prototype, "uid", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], IndexedRole.prototype, "name", void 0);
__decorate([
    toccata_1.validator.IsString()
], IndexedRole.prototype, "role", void 0);
__decorate([
    toccata_1.validator.IsBoolean(),
    toccata_1.validator.IsOptional()
], IndexedRole.prototype, "isAdmin", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], IndexedRole.prototype, "email", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], IndexedRole.prototype, "image", void 0);
exports.IndexedRole = IndexedRole;
class MeetGreetIndex extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.artistGroupMembers = [];
        this.slotCount = 0;
        this.sessionCount = 0;
    }
}
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], MeetGreetIndex.prototype, "artistGroupId", void 0);
__decorate([
    toccata_1.validator.IsArray(),
    toccata_1.validator.IsOptional()
], MeetGreetIndex.prototype, "artistGroupMembers", void 0);
__decorate([
    toccata_1.validator.IsString()
], MeetGreetIndex.prototype, "sessionId", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], MeetGreetIndex.prototype, "startDate", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], MeetGreetIndex.prototype, "endDate", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], MeetGreetIndex.prototype, "updatedAt", void 0);
__decorate([
    toccata_1.validator.IsArray()
], MeetGreetIndex.prototype, "uids", void 0);
__decorate([
    toccata_1.validator.IsString()
], MeetGreetIndex.prototype, "name", void 0);
__decorate([
    toccata_1.validator.IsString()
], MeetGreetIndex.prototype, "artist", void 0);
__decorate([
    toccata_1.validator.IsString()
], MeetGreetIndex.prototype, "eventId", void 0);
__decorate([
    toccata_1.validator.IsString()
], MeetGreetIndex.prototype, "eventName", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(EventAssets)
], MeetGreetIndex.prototype, "eventAssets", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], MeetGreetIndex.prototype, "sessionDuration", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], MeetGreetIndex.prototype, "unitPrice", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(IndexedRole, { each: true }),
    toccata_1.validator.IsOptional()
], MeetGreetIndex.prototype, "roles", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], MeetGreetIndex.prototype, "slotCount", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], MeetGreetIndex.prototype, "sessionCount", void 0);
exports.MeetGreetIndex = MeetGreetIndex;
//# sourceMappingURL=meetgreet.js.map